import { Container, SkeletonComponent } from '@design-system';

export const PointageSliderSkeleton: React.FC = () => {
    return (
        <div className="pointage-slider loading">
            <SkeletonComponent count={1} style={{ height: '84px', borderRadius: '0px' }} />

            <Container>
                <SkeletonComponent
                    count={1}
                    style={{
                        height: '69px',
                        marginBottom: '8px',
                        borderRadius: '14px'
                    }}
                />

                <SkeletonComponent
                    count={1}
                    style={{
                        height: '69px',
                        marginBottom: '8px',
                        borderRadius: '14px'
                    }}
                />

                <SkeletonComponent
                    count={1}
                    style={{
                        height: '69px',
                        marginBottom: '8px',
                        borderRadius: '14px'
                    }}
                />

                <SkeletonComponent
                    count={1}
                    style={{
                        height: '69px',
                        marginBottom: '8px',
                        borderRadius: '14px'
                    }}
                />

                <SkeletonComponent
                    count={1}
                    style={{
                        height: '69px',
                        marginBottom: '8px',
                        borderRadius: '14px'
                    }}
                />

                <SkeletonComponent
                    count={1}
                    style={{
                        height: '69px',
                        marginBottom: '8px',
                        borderRadius: '14px'
                    }}
                />

                <SkeletonComponent
                    count={1}
                    style={{
                        height: '91px',
                        marginTop: '16px',
                        borderRadius: '18px'
                    }}
                />
            </Container>
        </div>
    );
};
